import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { useEventos } from "../../context/EventosContext";

import { DashboardLayout, MainContent } from "../dash/styles";
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/cursos/header/Header";
import Midia from "../../components/cursos/midia/Midia";
import DetalhesCurso from "../../components/cursos/detalhesCurso/DetalhesCurso";
import ActionFooter from "../../components/actionFooter/ActionFooter";

import { Container } from "./styles";
import dayjs from "dayjs";


const getImagemUrl = (imagem) => {
  if (!imagem) return "https://placehold.co/600x200?text=Sem+Imagem";
  if (imagem.startsWith("http")) return imagem;

  const baseURL = api.defaults.baseURL;
  return `${baseURL}/${imagem.replace(/^\/?/, "")}`;
};

const normalizeTags = (tags) => {
  if (!tags) return [];
  if (Array.isArray(tags) && tags.length === 1 && typeof tags[0] === "string" && tags[0].startsWith("[")) {
    try { return JSON.parse(tags[0]); } catch { return []; }
  }
  if (Array.isArray(tags)) return tags.map((t) => t.trim());
  if (typeof tags === "string") {
    try { return JSON.parse(tags); } catch { return []; }
  }
  return [];
};

export default function EditarCursos() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { setEventos } = useEventos();

  const [eventoData, setEventoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvento = async () => {
      try {
        const response = await api.get(`/api/content/cursos/${id}`);
        const ev = response.data;

        setEventoData({
          titulo: ev.titulo || "",
          descricao: ev.descricao || "",
          organizacao: ev.organizacao || "",
          local: ev.local || "",
          dataInicio: ev.dataInicio ? dayjs(ev.dataInicio.$date || ev.dataInicio) : null,
          dataFim: ev.dataFim ? dayjs(ev.dataFim.$date) : null,
          hora: ev.hora ? dayjs(ev.hora, "HH:mm") : null,
          vagas: ev.vagas || 0,
          vagasOcupadas: ev.vagasOcupadas || 0,
          conteudos: ev.conteudos?.length ? ev.conteudos : [{ titulo: "", itens: [""] }],
          contatos: ev.contatos?.length
  ? ev.contatos.map((c) => ({
      id: crypto.randomUUID(),
      telefone: c.telefone || "",
      email: c.email || "",
      redeSocial: c.redeSocial || "",
    }))
  : [
      {
        id: crypto.randomUUID(),
        telefone: "",
        email: "",
        redeSocial: "",
      },
    ],
          tags: normalizeTags(ev.tags),
          destacado: Boolean(ev.destacado),
          status: ev.status || "Upcoming",
          imagem: ev.imagem || null,
          preview: getImagemUrl(ev.imagem),
        });
      } catch (error) {
        console.error("Erro ao buscar curso:", error);
        alert("Curso não encontrado.");
        navigate("/cursos");
      } finally {
        setLoading(false);
      }
    };

    fetchEvento();
  }, [id, navigate]);

  const handleSave = async () => {
    if (!eventoData) return;

    const formData = new FormData();

    formData.append("titulo", eventoData.titulo);
    formData.append("descricao", eventoData.descricao);
    formData.append("organizacao", eventoData.organizacao);
    formData.append("local", eventoData.local);

    if (eventoData.dataInicio) formData.append("dataInicio", dayjs(eventoData.dataInicio).toISOString());
    if (eventoData.dataFim) formData.append("dataFim", dayjs(eventoData.dataFim).toISOString());
    if (eventoData.hora) formData.append("hora", dayjs(eventoData.hora).format("HH:mm"));

    formData.append("status", eventoData.status);
    formData.append("vagas", String(eventoData.vagas || 0));
    formData.append("destacado", String(eventoData.destacado));
    formData.append("tags", JSON.stringify(eventoData.tags || []));
    formData.append("contatos", JSON.stringify(eventoData.contatos || []));
    formData.append("conteudos", JSON.stringify(eventoData.conteudos || []));

    if (eventoData.imagem instanceof File) formData.append("imagem", eventoData.imagem);

    try {
      const response = await api.put(`/api/content/cursos/${id}`, formData);

      if (setEventos) {
        setEventos((prev) => prev.map((ev) => (ev._id || ev.id) === id ? response.data : ev));
      }

      alert("Curso atualizado com sucesso!");
      navigate("/cursos");
    } catch (error) {
      console.error("Erro ao atualizar curso:", error);
      alert("Erro ao salvar alterações.");
    }
  };

  if (loading) return <p style={{ padding: 40 }}>Carregando curso...</p>;
  if (!eventoData) return <p style={{ padding: 40 }}>Curso não encontrado.</p>;

  return (
    <DashboardLayout>
      <Sidebar />
      <Container>
        <Header
          title="Editar curso"
          description="Atualize as informações do curso"
          breadcrumbMain="cursos"
          breadcrumbCurrent="Editar curso"
        />
        <MainContent>
          <Midia
            initialPreview={eventoData.preview}
            onFileSelect={(file, preview) => setEventoData({ ...eventoData, imagem: file, preview })}
          />
          <DetalhesCurso
            cursoData={eventoData}
            setCursoData={setEventoData}
          />
          <ActionFooter onSave={handleSave} />
        </MainContent>
      </Container>
    </DashboardLayout>
  );
}
